<template>
    <div>
      <email-verification v-if="!isEmailVerified" :account-number='accountNumber' :property='property' :user-property='userProperty' :user="user"></email-verification>

      <!-- <phone-verification v-if="isEmailVerified" :account-number='accountNumber' :property='property' :user-property='userProperty' :user="user"></phone-verification> -->
    </div>
</template>

<script>
export default {
  props: ["accountNumber", "property", "userProperty", "user", "isEmailVerified"],
};
</script>